import { render, staticRenderFns } from "./CotizacionesStatusGraphic.vue?vue&type=template&id=0bba68f2&scoped=true"
import script from "./CotizacionesStatusGraphic.vue?vue&type=script&lang=js"
export * from "./CotizacionesStatusGraphic.vue?vue&type=script&lang=js"
import style0 from "./CotizacionesStatusGraphic.vue?vue&type=style&index=0&id=0bba68f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba68f2",
  null
  
)

export default component.exports